<template>
  <div class="dynamicMobile">
    <section class="dynamic-top">
      <div class="dynamic-top-text">
        <p class="dynamic-top-text-title">小迈动态</p>
        <p>同步企业资讯及文化活动最新动态，促进企业品牌与文化的协同。</p>
      </div>
    </section>

    <!-- 二级导航栏 -->
    <sonNav :sonNavData="sonNavData"></sonNav>

    <div class="section-container">
      <!-- 企业资讯 -->
      <section
        class="dynamic-information-mobile animated"
        id="dynamicInformation"
        ref="dynamicInformation"
      >
        <div class="content">
          <div class="title-box">
            <span class="title">企业资讯</span>
            <span
              class="show-all"
              v-if="categoryOne.length > 3"
              @click="handleLinkMore(DYNAMICIN_FORMATION)"
              >查看全部<span class="icon-more"></span
            ></span>
          </div>
          <div
            class="article-content"
            v-if="categoryOne.length > 0"
            v-loading="listLoading"
          >
            <article-box-mobile
              v-for="(item, index) in categoryOne.slice(0, 3)"
              :key="item.id"
              :articleData="item"
              class="article-box-mobile"
              @click.native="
                handleShowDetail(DYNAMICIN_FORMATION, item.id, index)
              "
            />
          </div>
        </div>
      </section>

      <!-- 文化活动 -->
      <section
        class="dynamic-activity-mobile animated"
        id="dynamicActivity"
        ref="dynamicActivity"
      >
        <div class="content">
          <div class="title-box">
            <span class="title">文化活动</span>
            <span
              class="show-all"
              v-if="categoryTwo.length > 3"
              @click="handleLinkMore(DYNAMIC_ACTIVITY)"
              >查看全部<span class="icon-more"></span
            ></span>
          </div>
          <div
            class="article-content"
            v-if="categoryTwo.length > 0"
            v-loading="listLoading"
          >
            <article-box-mobile
              v-for="(item, index) in categoryTwo.slice(0, 3)"
              :key="item.id"
              :articleData="item"
              class="article-box-mobile"
              @click.native="handleShowDetail(DYNAMIC_ACTIVITY, item.id, index)"
            />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import CommonMethod from "utils/CommonMethod";
import sonNav from "../../../components/sonNav/mobile.vue";
import ArticleBoxMobile from "../../../components/ArticleBox/mobile/small";
import Vconsole from "vconsole";
import Config from "utils/Config";
import { getArticleListByDetail } from "@/api/dynamic.js";
import { DYNAMICIN_FORMATION, DYNAMIC_ACTIVITY } from "@/data/dynamicData.js";

export default {
  name: "dynamicMobile",
  props: {
    gData: Object,
  },
  components: {
    sonNav,
    ArticleBoxMobile,
  },
  data() {
    return {
      commonMethod: null,
      sonNavData: {
        navArr: [
          {
            id: "dynamicInformation",
            name: "企业资讯",
            categoryId: DYNAMICIN_FORMATION,
          },
          {
            id: "dynamicActivity",
            name: "文化活动",
            categoryId: DYNAMIC_ACTIVITY,
          },
        ],
        aniDistance: 50,
        ulWidth: "50%",
        showFixeNav: 0,
        aniClassName: "weakFadeInUp",
      },
      categoryOne: [],
      categoryTwo: [],
      listLoading: false,
      DYNAMICIN_FORMATION,
      DYNAMIC_ACTIVITY,
    };
  },
  created() {
    this.getCategoryList(DYNAMICIN_FORMATION, 4);
    this.getCategoryList(DYNAMIC_ACTIVITY, 4);

    this.commonMethod = new CommonMethod({
      context: this,
      judgeNavToFixedEleName: "#jude-nav-content",
    });

    if (process.env.NODE_ENV !== "production") this.vconsoel = new Vconsole();
  },
  computed: {},
  mounted() {
    this.commonMethod.init();
    this.commonMethod.modelFadeInupMobile({
      id: "dynamicInformation",
      autoPlay: true,
    });
    window.addEventListener("scroll", this.scrollHandle, true);
  },
  methods: {
    // 分Id取文章列表
    async getCategoryList(categoryId, pageSize) {
      try {
        this.listLoading = true;
        const paramMap = {
          categoryId: categoryId,
          pageSize: pageSize,
        };

        const res = await getArticleListByDetail(paramMap);
        if (!res.data) return;
        const listData = res.data.page;

        if (listData.list.length === 0) {
          // 某个tab没内容，处理一下sonNav
          let newNav = this.sonNavData.navArr.filter(
            (item) => item.categoryId !== categoryId
          );
          this.sonNavData.navArr = newNav;
          this.sonNavData.ulWidth = "64px";
        }

        if (categoryId === DYNAMICIN_FORMATION) {
          this.categoryOne = listData.list;
        } else if (categoryId === DYNAMIC_ACTIVITY) {
          this.categoryTwo = listData.list;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.listLoading = false;
      }
    },
    scrollHandle() {
      this.commonMethod.modelFadeInupMobile({ id: "dynamicActivity" });

      this.$set(this.sonNavData, "showFixeNav", this.commonMethod.navIsTop());
      this.commonMethod.showAnchorContentEvt();
    },
    handleLinkMore(categoryId) {
      window.location.href = `${Config.domain}/dynamicList.html?categoryId=${categoryId}`;
    },
    handleShowDetail(categoryId, articleId, index) {
      window.location.href = `${Config.domain}/dynamicDetail.html?categoryId=${categoryId}&id=${articleId}&index=${index}`;
    },
  },
};
</script>

<style lang="less" scoped>
section {
  position: relative;
}
li {
  list-style: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}
h2 {
  .h2Mo2;
}
img {
  width: 100%;
  display: block;
}

.dynamicMobile {
  width: 100%;

  .dynamic-top {
    .imgInfoM(100%, 160px, "dynamic/top/banner_dynamic@2x.png");
    position: relative;
    // .allCenter;
    .dynamic-top-text {
      position: absolute;
      display: inline-block;
      top: 20%;
      left: 6%;
      width: 436px;
      .dynamic-top-text-title {
        width: 72px;
        height: 27px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
        line-height: 27px;
      }
      p {
        width: 192px;
        height: 54px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        line-height: 18px;
      }
    }
  }

  .section-container {
    padding-bottom: 40px;
    border-bottom: 1px solid #e1e1e1;
    .dynamic-information-mobile,
    .dynamic-activity-mobile {
      .content {
        width: 89.3%;
        margin: 0 auto;
        padding-top: 55px;
        font-family: PingFangSC-Medium, PingFang SC;

        .title-box {
          color: #222222;
          font-size: 14px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .title {
            font-family: PingFangSC-Medium, PingFang SC;
            font-size: 24px;
            font-weight: 500;
            line-height: 36px;
          }

          .show-all {
            display: flex;
            align-items: center;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            .icon-more {
              display: inline-block;
              width: 24px;
              height: 24px;
              background-image: url("~@/assets/img/mobile/dynamic/activity/icon_arrow@2x.png");
              background-repeat: no-repeat;
              background-size: cover;
              background-position: center center;
            }
          }
        }

        .article-content {
          position: relative;
          display: grid;
          grid-template-columns: repeat(1, 100%);
          grid-gap: 16px 0;
          padding-top: 20px;
          .article-box-mobile {
            width: 100%;
            height: 88px;
          }
        }
      }
    }
  }
}
</style>